import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TBusinessRule {
  id: number;
  name: string;
  description: string;
  rule: string;
}

export interface IBusinessRule extends TBusinessRule {}

const BusinessRule = Model(
  (model: TBusinessRule): IBusinessRule => {
    const _businessRule: TBusinessRule = Object.assign({}, model);

    let create = (businessRule: IBusinessRule): IBusinessRule => {
      let obj = ValidatableObject(businessRule);
      return obj;
    };

    let businessRule = {
      get id() {
        return _businessRule.id;
      },
      set id(value) {
        _businessRule.id = value;
      },
      get name() {
        return _businessRule.name;
      },
      set name(value) {
        _businessRule.name = value;
      },
      get description() {
        return _businessRule.description;
      },
      set description(value) {
        _businessRule.description = value;
      },
      get rule() {
        return _businessRule.rule;
      },
      set rule(value) {
        _businessRule.rule = value;
      }
    };

    return create(businessRule);
  }
);

export default BusinessRule;
